import React, { useEffect, useState } from 'react';
import './QuestionList.css'; // Importe o arquivo CSS

import confetti from "canvas-confetti";
function QuestionList() {

  //const [questions, setQuestions] = useState([]); 

  const questions = [
    {
      "id": 5,
      "question": "Qual dos seguintes rios é conhecido por ser um dos mais importantes para o abastecimento de água na região Sudeste do Brasil?",
      "options": [
        "Rio Amazonas",
        "Rio Paraíba do Sul",
        "Rio Paraná"
      ],
      "correct_option": 1,
      "difficulty": "iniciante",
      "category": "Ciências ambientais",
      "points": 10,
      "explanation": "O rio mais importante para o abastecimento de água na região Sudeste do Brasil é o Rio Paraíba do Sul."
    },
    {
      "id": 6,
      "question": "O Rio Guandu desempenha um papel crucial no abastecimento de água para qual região?",
      "options": [
        "Nordeste do Brasil",
        "Norte do Brasil",
        "Região Metropolitana do Rio de Janeiro"
      ],
      "correct_option": 2,
      "difficulty": "iniciante",
      "category": "Ciências ambientais",
      "points": 10,
      "explanation": "O Rio Guandu desempenha um papel crucial no abastecimento de água para a Região Metropolitana do Rio de Janeiro."
    },
    {
      "id": 8,
      "question": "Qual é a principal função do Rio Guandu para a Região Metropolitana do Rio de Janeiro?",
      "options": [
        "Transporte de mercadorias",
        "Geração de energia hidrelétrica",
        "Abastecimento de água potável"
      ],
      "correct_option": 2,
      "difficulty": "iniciante",
      "category": "Ciências ambientais",
      "points": 10,
      "explanation": "A principal função do Rio Guandu para a Região Metropolitana do Rio de Janeiro é o Abastecimento de água potável."
    },
    {
      "id": 9,
      "question": "Em qual região hidrográfica Vassouras pertence?",
      "options": [
        "RH2",
        "RH3",
        "RH2 e RH3"
      ],
      "correct_option": 2,
      "difficulty": "iniciante",
      "category": "Ciências ambientais",
      "points": 10,
      "explanation": "Vassouras pertence à região hidrográfica RH2 e RH3."
    },
    {
      "id": 10,
      "question": "Onde está localizada a foz do Microbicida Rio das Mortes?",
      "options": [
        "Rio Guandu",
        "Rio Alegre",
        "Rio Paraíba do Sul"
      ],
      "correct_option": 2,
      "difficulty": "iniciante",
      "category": "Ciências ambientais",
      "points": 10,
      "explanation": "A foz do Microbicida Rio das Mortes está localizada no Rio Paraíba do Sul."
    },
    {
      "id": 11,
      "question": "O Rio Guandu é uma fonte de água para qual importante sistema de abastecimento?",
      "options": [
        "Sistema Cantareira",
        "Sistema Guandu",
        "Sistema Cantagalo"
      ],
      "correct_option": 1,
      "difficulty": "iniciante",
      "category": "Geografia",
      "points": 10,
      "explanation": "O Rio Guandu é uma fonte de água para o Sistema Guandu."
    },
    {
      "id": 12,
      "question": "O Rio Guandu é impactado por problemas ambientais, como a poluição. Qual é uma das principais fontes de poluição no Rio Guandu?",
      "options": [
        "Desmatamento das margens",
        "Despejo inadequado de resíduos industriais e domésticos",
        "Atividade de mineração nas proximidades"
      ],
      "correct_option": 1,
      "difficulty": "intermediario",
      "category": "Meio Ambiente",
      "points": 10,
      "explanation": "Uma das principais fontes de poluição no Rio Guandu é o despejo inadequado de resíduos industriais e domésticos."
    },
    {
      "id": 13,
      "question": "O que é uma bacia hidrográfica?",
      "options": [
        "Uma região montanhosa",
        "Uma área de captação de água que drena para um único rio ou sistema de rios",
        "Uma área desértica"
      ],
      "correct_option": 1,
      "difficulty": "iniciante",
      "category": "Geografia",
      "points": 10,
      "explanation": "Uma bacia hidrográfica é uma área de captação de água que drena para um único rio ou sistema de rios."
    },
    {
      "id": 14,
      "question": "O que é uma microbacia hidrográfica?",
      "options": [
        "Uma pequena área de drenagem que contribui para um córrego ou riacho",
        "Uma área desértica",
        "Uma bacia hidrográfica de grande porte"
      ],
      "correct_option": 0,
      "difficulty": "intermediario",
      "category": "Geografia",
      "points": 10,
      "explanation": "Uma microbacia hidrográfica é uma pequena área de drenagem que contribui para um córrego ou riacho."
    },
    {
      "id": 15,
      "question": "O que caracteriza um afluente?",
      "options": [
        "Um rio principal que flui para o oceano",
        "Um rio que deságua em outro rio",
        "Um canal de irrigação"
      ],
      "correct_option": 1,
      "difficulty": "iniciante",
      "category": "Geografia",
      "points": 10,
      "explanation": "Um afluente é caracterizado por ser um rio que deságua em outro rio."
    },
    {
      "id": 16,
      "question": "Qual é a importância das microbacias hidrográficas?",
      "options": [
        "Elas não têm importância significativa.",
        "São fundamentais para preservar a qualidade da água e a biodiversidade local.",
        "São utilizadas para fins recreativos."
      ],
      "correct_option": 1,
      "difficulty": "intermediario",
      "category": "Meio Ambiente",
      "points": 10,
      "explanation": "As microbacias hidrográficas são fundamentais para preservar a qualidade da água e a biodiversidade local."
    },
    {
      "id": 17,
      "question": "Em que etapa do tratamento de água ocorre a adição de produtos químicos para coagulação e floculação?",
      "options": [
        "Filtração",
        "Decantação",
        "Coagulação/Floculação"
      ],
      "correct_option": 2,
      "difficulty": "avancado",
      "category": "Química",
      "points": 10,
      "explanation": "A adição de produtos químicos para coagulação e floculação ocorre na etapa de Coagulação/Floculação do tratamento de água."
    },
    {
      "id": 18,
      "question": "Quando se realiza a etapa de desinfecção da água tratada?",
      "options": [
        "Antes da coagulação",
        "Após a filtração",
        "Durante a decantação"
      ],
      "correct_option": 1,
      "difficulty": "avancado",
      "category": "Química",
      "points": 10,
      "explanation": "A etapa de desinfecção da água tratada é realizada após a filtração."
    },
    {
      "id": 19,
      "question": "Qual é o principal objetivo da etapa de filtração no tratamento de água?",
      "options": [
        "Remover partículas sólidas suspensas",
        "Adicionar cloro para desinfecção",
        "Ajustar o pH da água"
      ],
      "correct_option": 0,
      "difficulty": "avancado",
      "category": "Química",
      "points": 10,
      "explanation": "O principal objetivo da etapa de filtração no tratamento de água é remover partículas sólidas suspensas."
    },
    {
      "id": 20,
      "question": "Qual é o processo utilizado para eliminar microrganismos patogênicos da água tratada?",
      "options": [
        "Decantação",
        "Filtração",
        "Desinfecção"
      ],
      "correct_option": 2,
      "difficulty": "avancado",
      "category": "Química",
      "points": 10,
      "explanation": "O processo utilizado para eliminar microrganismos patogênicos da água tratada é a Desinfecção."
    },
    {
      "id": 21,
      "question": "Qual é o propósito da adição de flúor à água tratada?",
      "options": [
        "Melhorar o sabor da água",
        "Prevenir a formação de algas",
        "Fortalecer os dentes"
      ],
      "correct_option": 2,
      "difficulty": "avancado",
      "category": "Saúde Pública",
      "points": 10,
      "explanation": "O propósito da adição de flúor à água tratada é fortalecer os dentes."
    }
  ];

  const [currentPage, setCurrentPage] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [resultMessage, setResultMessage] = useState('');
  const [explanation, setExplanation] = useState('');
  const [currentPageAnswers, setCurrentPageAnswers] = useState({});
  const [totalScore, setTotalScore] = useState(0);

/*   useEffect(() => {
    // Fazer a requisição HTTP para o endpoint do backend
    fetch('http://localhost:3000/api/questions')
      .then((response) => response.json())
      .then((data) =>
        setQuestions(data.map((question) => ({ ...question, selectedOption: null })))
      )
      .catch((error) => console.error('Erro ao buscar perguntas:', error));
  }, []); */
  
  const loadConfettiAllPage = () => {
    setTimeout(() => {
      confetti({
        particleCount: 100,
        startVelocity: 30,
        spread: 360,
        zIndex: 99999999999999,
        origin: {
          x: Math.random(),
          // since they fall down, start a bit higher than random
          y: Math.random() - 0.2
        }
      });
    }, 0);
  
    setTimeout(() => {
      confetti({
        particleCount: 100,
        startVelocity: 30,
        spread: 360,
        zIndex: 99999999999999,
        origin: {
          x: Math.random(),
          // since they fall down, start a bit higher than random
          y: Math.random() - 0.2
        }
      });
    }, 0);
  
    setTimeout(() => {
      confetti({
        particleCount: 100,
        startVelocity: 30,
        spread: 360,
        zIndex: 99999999999999,
        origin: {
          x: Math.random(),
          // since they fall down, start a bit higher than random
          y: Math.random() - 0.2
        }
      });
    }, 0);
  
    setTimeout(() => {
      confetti({
        particleCount: 100,
        startVelocity: 30,
        spread: 360,
        zIndex: 99999999999999,
        origin: {
          x: Math.random(),
          // since they fall down, start a bit higher than random
          y: Math.random() - 0.2
        }
      });
    }, 0);
  
    setTimeout(() => {
      confetti({
        particleCount: 100,
        startVelocity: 30,
        spread: 360,
        zIndex: 99999999999999,
        origin: {
          x: Math.random(),
          // since they fall down, start a bit higher than random
          y: Math.random() - 0.2
        }
      });
    }, 0);
  };

  const questionsPerPage = 1; // Define o número de perguntas por página

  const handleOptionSelection = (questionId, optionIndex) => {
    setCurrentPageAnswers((prevState) => ({
      ...prevState,
      [questionId]: optionIndex,
    }));
  };

  const handleAnswer = () => {
    const currentQuestion = questions[currentPage];
    console.log('currentQuestion: ', currentQuestion);
    const selectedOption = currentPageAnswers[currentQuestion.id];
    const correct_option = currentQuestion?.correct_option;

    if (selectedOption === correct_option) {
      console.log(`Acertou! A resposta correta é a ${correct_option}!`);
      setTotalScore((oldValue) => oldValue + 1);
      setResultMessage('Você acertou!');
      setExplanation(`👍 Você acertou! ` + currentQuestion.explanation);
      loadConfettiAllPage();
    } else {
      console.log(`Errou, a resposta correta é a ${correct_option}!`);
      setResultMessage('Você errou!');
      setExplanation(`👎 Você errou! ` + currentQuestion.explanation);
    }

    setShowResult(true);
  };

  const handleNextPage = () => {
    setCurrentPage((prevState) => prevState + 1);
    setShowResult(false);
    setResultMessage('');
    setExplanation('');
    setCurrentPageAnswers({});
  };

  const startIndex = currentPage * questionsPerPage;
  const endIndex = startIndex + questionsPerPage;


  return (
    <div className="QuestionList"> {/* Adicione a classe QuestionList ao contêiner principal */}
      <h1>Pergunta {currentPage + 1} de {Math.ceil(questions.length / questionsPerPage)}</h1>
      <ul>
        {questions.length > 0 && questions.slice(startIndex, endIndex).map((question) => (
          <li key={question.id}>
            <h2 className='title-question'>{question.question}</h2>
            <ul>
              {question.options.map((option, index) => (
                <li key={index}>
                  <label disabled={showResult} style={showResult? { cursor: 'not-allowed' } : {}}>
                    <input
                      type="radio"
                      className='inputStyle'
                      name={question.id}
                      checked={currentPageAnswers[question.id] === index}
                      onChange={() => handleOptionSelection(question.id, index)}
                      disabled={showResult}
                    />
                    {option}
                  </label>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
      {!showResult && (
        <button className='btnn' onClick={handleAnswer} disabled={Object.keys(currentPageAnswers).length < questionsPerPage}>
          Responder
        </button>
      )}
      {showResult && (
        <div className="result"> {/* Adicione a classe result à seção de resultado */}
         
          <p className="explanation">{explanation}</p>
          {currentPage < Math.ceil(questions.length / questionsPerPage) - 1 && (
            <button onClick={handleNextPage}>Próxima Pergunta</button>
          )}
          <p className="total-score">Você acertou {totalScore} de {questions.length} perguntas ({((totalScore / questions.length) * 100).toFixed(2)}%).</p>
        </div>
      )}
    </div>
  );
}

export default QuestionList;
